import { apiService } from "api/apiService";
import type { MyLessonGroupLearningObjectivesResource } from "api/generated";

export const fetchLessonClassLearningGoals = async (
  scheduleId: string,
  periodId: number,
  signal?: AbortSignal,
): Promise<MyLessonGroupLearningObjectivesResource> => {
  const url = `/api/my-lessongroups/${encodeURIComponent(scheduleId)}/learning-goals`;

  const { data } =
    await apiService.get<MyLessonGroupLearningObjectivesResource>(url, {
      params: { "period-id": periodId },
      signal,
    });

  return data;
};
